
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import Page from "@/src/components/Page";
import PricingShell3 from "@/src/layouts/PricingShell3";

const Pricing = () => {
    return (
        <PricingShell3 />
    );
};

const PricingPage = () => (
    <Page name="Pricing" path="/pricing/">
        <Pricing/>
    </Page>
);

export default PricingPage;

    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/pricing/index',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  